const BASE_URL = process.env.REACT_APP_BASE_URL || '';

async function requestJson(path, init = {}) {
  const url = `${BASE_URL}${path}`;
  const res = await fetch(url, init);
  const contentType = res.headers.get('content-type') || '';
  const text = await res.text();
  const body = contentType.includes('application/json') && text ? JSON.parse(text) : text;
  if (!res.ok) {
    const err = new Error((body && body.message) || text || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export async function login(email) {
  return requestJson('/api/users/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
}

export async function register(name, email, acceptsMarketing = true) {
  return requestJson('/api/users/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, acceptsMarketing }),
  });
}

export async function refreshToken() {
  const token = localStorage.getItem('token');
  return requestJson('/api/users/refresh-token', {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` },
  });
}

export default { login, register, refreshToken };
